import { toast } from "react-hot-toast";

import "./CopyTextControl.scss";

export const CopyTextControl = (props: {
  value: string;
}): JSX.Element => {
  const onClick = () => {
    navigator.clipboard.writeText(props.value);
    toast.success("Text copied.");
  };

  return (
    <div className="copyControl">
      <input type="text" readOnly value={props.value} />
      <button onClick={onClick}>Copy</button>
    </div>
  );
};
